<template>
  <a-layout-header
    class="header"
  >
    <a-space
      size="middle"
      class="space-flex"
    >
      <a href="/">
        <img
          :src="require('@/assets/images/logo.svg')"
          class="logo"
          alt="Logo"
        >
      </a>
      <!-- <a-button
        id="back-to-old-btn"
        shape="round"
        size="small"
        href="/okr"
        :style="{ color: '#7F7F7F' }"
      >
        {{ $t('layout.header.backToOld') }}
      </a-button> -->
    </a-space>
    <UserSearchBar />
    <a-space size="middle">
      <a-popover placement="bottom">
        <template #content>
          <img
            :src="$t('layout.header.vipGroupSrc')"
            alt="VIP 答疑群"
            :style="{ width: '180px' }"
          >
        </template>
        <a-button type="text">
          <template #icon>
            <CustomerServiceFilled />
          </template>
          {{ $t('layout.header.customerServiceGroup') }}
        </a-button>
      </a-popover>
      <TheUser :user="user" />
      <a-radio-group
        id="language-switcher"
        :value="lang"
        button-style="solid"
        size="small"
        @change="e => onChangeLanguage(e.target.value)"
      >
        <a-radio-button value="zh-CN">
          中文
        </a-radio-button>
        <a-radio-button value="en-US">
          English
        </a-radio-button>
      </a-radio-group>
    </a-space>
  </a-layout-header>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { CustomerServiceFilled } from '@ant-design/icons-vue'

import UserSearchBar from './UserSearchBar'
import TheUser from './TheUser'

export default {
  components: {
    CustomerServiceFilled,
    UserSearchBar,
    TheUser
  },
  setup () {
    const store = useStore()
    const user = computed(() => store.state.user)
    const lang = computed(() => store.getters.lang)

    function onChangeLanguage (lang) {
      store.dispatch('setLang', lang)
    }

    return {
      user,
      onChangeLanguage,
      lang
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding: 0 24px;
}

.logo {
  height: 36px;
}
</style>
